import React, { Component } from "react"
import { Link } from "gatsby"
import "./index.css"

import {
  Collapse,
  NavItem,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
} from "reactstrap"
import MegaMenu from "../Mega-Menu"

class NavBarTop extends Component {
  constructor(props) {
    super(props)
    this.toggle = this.toggle.bind(this)
    this.state = {
      isOpen: false,
      menuOpen: false,
    }
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }

  megaToggle = () => {
    this.setState({
      menuOpen: !this.state.menuOpen,
    })
  }

  render() {
    return (
      <React.Fragment>
        <Navbar className="my-navbar p-0" dark expand="lg">
          <div className="d-flex justify-content-start">
            <NavbarBrand href="/" className="logo-wrap text-white p-0">
              <img
                className="img-fluid"
                src={require("../../../images/Logos/win-logo.png")}
              />
            </NavbarBrand>
          </div>

          <NavbarToggler onClick={this.toggle} className="text-light" />
          <Collapse
            className="menu-collapse-mob"
            isOpen={this.state.isOpen}
            navbar
          >
            <Nav className="justify-content-between" navbar>
              <NavItem
                className="pl-lg-2 pl-md-0 mega-toggle-icon"
                onClick={this.megaToggle}
              >
                <i className="text-white nav-link fa fa-bars navbar-top-toggle-icon"></i>
              </NavItem>
              <NavItem className="pl-lg-2 pl-md-0">
                <Link
                  className="text-white nav-link navbar-link"
                  to="/all-show-nodes"
                >
                  Shows
                </Link>
              </NavItem>
              <NavItem className="pl-lg-2 pl-md-0">
                <Link
                  className="text-white nav-link navbar-link"
                  to="/schedule"
                >
                  SpielPlan
                </Link>
              </NavItem>

              <NavItem className="pl-lg-2 pl-md-0 ">
                <Link
                  className="text-white nav-link navbar-link"
                  to="/gastronomie"
                >
                  Gastromonie
                </Link>
              </NavItem>
              <NavItem className="pl-lg-2 pl-md-0">
                <Link
                  className="text-white nav-link navbar-link"
                  to="/event-locations"
                >
                  EventLocation
                </Link>
              </NavItem>
              <NavItem className="pl-lg-2 pl-md-0">
                <Link
                  className="text-white nav-link navbar-link"
                  to="/services"
                >
                  Service
                </Link>
              </NavItem>
              <NavItem className="pl-lg-2 pl-md-0">
                <Link className="text-white nav-link navbar-link" to="/presse">
                  Presse
                </Link>
              </NavItem>
              <NavItem className="pl-lg-2 pl-md-0">
                <Link className="text-white nav-link navbar-link" to="/about">
                  DAS HAUS
                </Link>
              </NavItem>

              <div className="mob-nav-right-link">
                <NavItem className="pl-lg-2 pl-md-0">
                  <Link className="text-white nav-link navbar-link" to="/">
                    EN
                  </Link>
                </NavItem>
                <NavItem className="pl-lg-2 pl-md-0">
                  <Link className="text-white nav-link navbar-link" to="/">
                    <i className="fa fa-phone navbar-top-toggle-icon"></i> 030
                    588 433
                  </Link>
                </NavItem>
              </div>
            </Nav>
          </Collapse>

          <div className=" justify-content-between desktop-nav-right-link">
            <NavItem className="pl-lg-2 pl-md-0 nav-right-link">
              <Link className="text-white nav-link navbar-link" to="/">
                EN
              </Link>
            </NavItem>
            <NavItem className="pl-lg-2 pl-md-0 nav-right-link">
              <Link className="text-white nav-link navbar-link" to="/">
                <i className="fa fa-phone navbar-top-toggle-icon"></i> 030 588
                433
              </Link>
            </NavItem>
          </div>
        </Navbar>

        {this.state.menuOpen && <MegaMenu onClick={this.megaToggle} />}
      </React.Fragment>
    )
  }
}

export default NavBarTop
